import type { ComponentProps } from "react";

export default function ClientProfileIcon({
  fill,
  ...props
}: ComponentProps<"svg">) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2852_46320)">
        <path
          d="M8.87062 8.67065C10.0618 8.67065 11.0933 8.24342 11.9361 7.4005C12.7789 6.55771 13.2061 5.52651 13.2061 4.33519C13.2061 3.14427 12.7789 2.11294 11.9359 1.26988C11.093 0.427229 10.0617 0 8.87062 0C7.67929 0 6.64809 0.427229 5.80531 1.27001C4.96252 2.1128 4.53516 3.14414 4.53516 4.33519C4.53516 5.52651 4.96252 6.55785 5.80545 7.40064C6.64837 8.24328 7.67971 8.67065 8.87062 8.67065Z"
          fill={fill || "#183E7A"}
        />
        <path
          d="M16.4576 13.8417C16.4333 13.491 16.3841 13.1084 16.3118 12.7043C16.2387 12.2973 16.1446 11.9125 16.032 11.5608C15.9157 11.1973 15.7575 10.8383 15.5619 10.4943C15.359 10.1373 15.1206 9.82635 14.8531 9.57051C14.5733 9.30285 14.2308 9.08766 13.8348 8.93069C13.4401 8.77455 13.0027 8.69545 12.5348 8.69545C12.3511 8.69545 12.1734 8.77084 11.8302 8.99428C11.619 9.13202 11.3719 9.29132 11.0962 9.46751C10.8604 9.61775 10.5409 9.75851 10.1464 9.88595C9.76146 10.0105 9.37062 10.0737 8.98486 10.0737C8.59911 10.0737 8.20841 10.0105 7.82306 9.88595C7.42893 9.75865 7.10951 9.61789 6.87399 9.46765C6.60084 9.2931 6.35365 9.1338 6.13928 8.99414C5.79651 8.77071 5.61867 8.69531 5.43492 8.69531C4.96691 8.69531 4.52965 8.77455 4.13511 8.93083C3.73933 9.08752 3.39669 9.30272 3.11668 9.57064C2.8493 9.82663 2.61076 10.1374 2.40806 10.4943C2.21264 10.8383 2.05444 11.1972 1.93799 11.5609C1.82551 11.9126 1.73144 12.2973 1.65839 12.7043C1.58601 13.1078 1.53685 13.4906 1.51254 13.8421C1.48865 14.1865 1.47656 14.544 1.47656 14.905C1.47656 15.8446 1.77525 16.6053 2.36425 17.1663C2.94598 17.7199 3.7157 18.0007 4.65174 18.0007H13.3188C14.2548 18.0007 15.0243 17.72 15.6062 17.1663C16.1953 16.6057 16.494 15.8449 16.494 14.9049C16.4939 14.5422 16.4816 14.1845 16.4576 13.8417Z"
          fill={fill || "#183E7A"}
        />
      </g>
      <defs>
        <clipPath id="clip0_2852_46320">
          <rect width="17.9999" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
